import { Auth } from 'aws-amplify';
import React from 'react';
import { useDispatch } from 'react-redux';
import { authActions } from 'src/redux/auth/actions';
import { persistor } from '../../redux/store';

/**
 * A hook that returns a function which can be called to sign the user out.
 * This function:
 * - Clears the redux store of all user information.
 * - Signs the user out of AWS Cognito.
 * - Clears the user's history.
 */
export const useLogOut = () => {
  const dispatch = useDispatch();

  return React.useCallback(async () => {
    // Clear auth info in redux.
    dispatch(authActions.logOut());

    // Pause the persistor to avoid race conditions.
    persistor.pause();

    // Delete all persisted data.
    await persistor.purge();

    // Resume the persistor.
    persistor.persist();

    // Hack to allow for app to redirect to hosted UI
    // SEE: https://github.com/aws-amplify/amplify-js/blob/c78cf7003925ffdb235217daa41ea18d3845e52d/packages/auth/src/Auth.ts#L1354
    localStorage.setItem('amplify-signin-with-hostedUI', 'true');
    await Auth.signOut();
  }, [dispatch]);
};
